import {
    getAllDept,
    physician,
    getNoticeSetup,
    setNoticeSetup,
    getAllHospital,
    updateHospitalInPhysician
} from '../../../service/service'
export default {
  name:'mine',
  data: function() {
    return {
        specialtylList:[],
        columns1: [
            {
                title: this.$t('Software'),
                key: 'licenseName'
            },{
                title: this.$t('Expiration Date'),
                key: 'licenseDuration'
            }
        ],
      softwareLicense: [],
      modal:false,
      modal1:false,
      modal2:false,
      modal10:false,
      myName:'',
      myCompany:'',
      myPhoneNumber:'',
      myEmail:'',
      newEmail:'',
      oldPassword:'',
      newPassword:'',
      confirmNewPassword:'',
      hosList:[1,1,1],
      hospitalInputList:[
        {hospitalId:''}
      ],
      loginInfo:{},
      myProfile:{},
      surgery:"",
      switch1:true,
      switch2:true,
      switch3:true,
      switch4:true,
      switch5:true,
      switch6:true,
      switch7:true,
      switch8:true,
      switch9:true,
      switch10:true,
      switch11:true,
      switch12:true,
      switch13:true,
      switch14:true,
      switch15:true,
      switch16:true,
      switch17:true,
      switch18:true,
      hospitalList:[],
      emailRe: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
      pwdRe:  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}/,
      editPhone: '',
      countryCode: '+1'
    }
  },
  methods: {
    displayPhone1(){
        this.editPhone = this.editPhone.replace(/\D/g,'');
        // console.log(this.newPhone)
    },
    onSelectHos(e,i){
        console.log(e)
        console.log(i)
    },
    delHospital(index){
      this.hospitalInputList.splice(index,1)
    },
    addHospital(){
        if(this.hospitalInputList.length<10){
            let obj={
                hospitalId:''
            }
            this.hospitalInputList.push(obj)
        }
      // let arr = hospitalInputList
      // arr.push(obj)
      // this.hospitalInputList = arr
    },
    changeLang(e){
      localStorage.setItem("locale", e)
      window.location.reload()
    },
    ok10(){
        this.modal10 = false
        localStorage.removeItem('token')
        sessionStorage.removeItem('token')
        window.location.reload()
    },
    ok2(){
        if(this.oldPassword === ''){
            this.$Message.warning('The old password cannot be empty.')
            return
        }
        if(this.confirmNewPassword === this.newPassword){
            if(this.newPassword.length > 7){
                let p = {
                    id: this.token,
                    oldpwd: this.oldPassword,
                    newpwd: this.newPassword
                }
                physician.mine.changePassword(p).then(res=>{
                    let code = parseInt(res.code)
                    if(!code){
                        this.modal2 = false
                        this.modal10 = true
                    }else{
                        this.$Message.warning(res.msg)
                    }
                })
            }else{
                this.$Message.warning('The password must be at least 8 characters.')
            }
        }else{
            this.$Message.warning('The two passwords are not the same')
        }
    },
    cancel2 () {
      this.modal2 = false
    },
    showModify2(){
      this.modal2 = true
    },
    ok1(){
        if (this.emailRe.test(this.newEmail)) {
            let p = {
                token: this.token,
                newEmail: this.newEmail
            }
            physician.mine.changeEmailLogin(p).then(res=>{
                let code = parseInt(res.code)
                if(!code){
                    this.modal1 = false
                    this.reloadView()
                }else{
                    if(res.msg === ''){
                        this.$Message.warning(this.$t('fail'))
                    }else{
                        this.$Message.warning(this.$t(res.msg))
                    }
                }
            })
        }else{
            this.$Message.warning(this.$t('Invalid email address'))
        }
    },
    cancel1 () {
        this.newEmail = ''
        this.modal1 = false
    },
    showModify1(){
      this.modal1 = true
    },
    ok(){
        // console.log(this.hospitalInputList)
        // hospital JSON.stringify(this.hospitalInputList)
        let hosStr = ''
        this.hospitalInputList.forEach((i)=>{
            hosStr = hosStr + i.hospitalId + ','
        })
        if(hosStr === ''){
            this.$Message.error('Hospital cannot be empty')
            return
        }
        physician.mine.myProfile({
            token: this.token,
            name: this.myName,
            specialty: this.surgery,
            phoneNumber: this.countryCode +' '+ this.editPhone
        }).then(res=>{
            let code = parseInt(res.code)
            if(!code){
                updateHospitalInPhysician({
                    userId: this.token,
                    doctorId: this.token,
                    hospitalId: hosStr
                }).then(res=>{
                    console.log(res)
                    location.reload()
                })
                this.modal = false
            }else{
                this.$Message.warning(this.$t('fail'))
            }
        })
    },
    cancel () {
      this.modal = false
    },
    showModify(){
        this.reloadView()
        this.modal = true
        console.log(this.myProfile)
        this.myName = this.myProfile.name
        this.surgery = this.myProfile.specialty
        let arrHos = this.myProfile.hospital
        let arrNew = []
        arrHos.forEach(i=>{
            this.hospitalList.forEach(k=>{
                if(i != '' && i === k.hospitalName){
                    let obj = {
                        hospitalId: k.hospitalId
                    }
                    arrNew.push(obj)
                }
            })
        })
        this.hospitalInputList = arrNew
        console.log(this.hospitalInputList)
        let aa = this.myProfile.phoneNumber.indexOf('+1 ')
        // let aa = str.indexOf('+1 ')
        let str1 = ''
        let str2 = ''
        if(aa === 0){
            str1 = this.myProfile.phoneNumber.substr(3)
            str2 = this.myProfile.phoneNumber.substr(0,2)

        }else if(aa === -1){
            str1 = this.myProfile.phoneNumber.substr(4)
            str2 = this.myProfile.phoneNumber.substr(0,3)
        }
        this.editPhone = str1
        this.countryCode = str2
        this.myPhoneNumber = this.myProfile.phoneNumber
    },
    change1(){
        let status = ''
        if(this.switch1 && this.switch2){
            status = 'ET'
        }else if(!this.switch1 && this.switch2){
            status = 'T'
        }else if(this.switch1 && !this.switch2){
            status = 'E'
        }else if(!this.switch1 && !this.switch2){
            status = 'N'
        }
        setNoticeSetup({
            userId: this.token,
            autonewcase: status
        }).then(res=>{
            if(res.code === '0'){
                this.$Message.success(this.$t('success'))
            }else{
                this.$Message.warning(this.$t('fail'))
                this.reloadView()
            }
        })
    },
    change2(){
        let status = ''
        if(this.switch3 && this.switch4){
            status = 'ET'
        }else if(!this.switch3 && this.switch4){
            status = 'T'
        }else if(this.switch3 && !this.switch4){
            status = 'E'
        }else if(!this.switch3 && !this.switch4){
            status = 'N'
        }
        setNoticeSetup({
            userId: this.token,
            autonewcomment: status
        }).then(res=>{
            if(res.code === '0'){
                this.$Message.success(this.$t('success'))
            }else{
                this.$Message.warning(this.$t('fail'))
                this.reloadView()
            }
        })
    },
    change3(){
        let status = ''
        if(this.switch5 && this.switch6){
            status = 'ET'
        }else if(!this.switch5 && this.switch6){
            status = 'T'
        }else if(this.switch5 && !this.switch6){
            status = 'E'
        }else if(!this.switch5 && !this.switch6){
            status = 'N'
        }
        setNoticeSetup({
            userId: this.token,
            customnewcase: status
        }).then(res=>{
            if(res.code === '0'){
                this.$Message.success(this.$t('success'))
            }else{
                this.$Message.warning(this.$t('fail'))
                this.reloadView()
            }
        })
    },
    change4(){
        let status = ''
        if(this.switch7 && this.switch8){
            status = 'ET'
        }else if(!this.switch7 && this.switch8){
            status = 'T'
        }else if(this.switch7 && !this.switch8){
            status = 'E'
        }else if(!this.switch7 && !this.switch8){
            status = 'N'
        }
        setNoticeSetup({
            userId: this.token,
            customnewcomment: status
        }).then(res=>{
            if(res.code === '0'){
                this.$Message.success(this.$t('success'))
            }else{
                this.$Message.warning(this.$t('fail'))
                this.reloadView()
            }
        })
    },
    change5(){
        let status = ''
        if(this.switch9 && this.switch10){
            status = 'ET'
        }else if(!this.switch9 && this.switch10){
            status = 'T'
        }else if(this.switch9 && !this.switch10){
            status = 'E'
        }else if(!this.switch9 && !this.switch10){
            status = 'N'
        }
        setNoticeSetup({
            userId: this.token,
            statusupdates: status
        }).then(res=>{
            if(res.code === '0'){
                this.$Message.success(this.$t('success'))
            }else{
                this.$Message.warning(this.$t('fail'))
                this.reloadView()
            }
        })
    },
    change6(){
        let status = ''
        if(this.switch11 && this.switch12){
            status = 'ET'
        }else if(!this.switch11 && this.switch12){
            status = 'T'
        }else if(this.switch11 && !this.switch12){
            status = 'E'
        }else if(!this.switch11 && !this.switch12){
            status = 'N'
        }
        setNoticeSetup({
            userId: this.token,
            modification: status
        }).then(res=>{
            if(res.code === '0'){
                this.$Message.success(this.$t('success'))
            }else{
                this.$Message.warning(this.$t('fail'))
                this.reloadView()
            }
        })
    },
    change7(){
        let status = ''
        if(this.switch13 && this.switch14){
            status = 'ET'
        }else if(!this.switch13 && this.switch14){
            status = 'T'
        }else if(this.switch13 && !this.switch14){
            status = 'E'
        }else if(!this.switch13 && !this.switch14){
            status = 'N'
        }
        setNoticeSetup({
            userId: this.token,
            completion: status
        }).then(res=>{
            if(res.code === '0'){
                this.$Message.success(this.$t('success'))
            }else{
                this.$Message.warning(this.$t('fail'))
                this.reloadView()
            }
        })
    },
    change8(){
        let status = ''
        if(this.switch15 && this.switch16){
            status = 'ET'
        }else if(!this.switch15 && this.switch16){
            status = 'T'
        }else if(this.switch15 && !this.switch16){
            status = 'E'
        }else if(!this.switch15 && !this.switch16){
            status = 'N'
        }
        setNoticeSetup({
            userId: this.token,
            profile: status
        }).then(res=>{
            if(res.code === '0'){
                this.$Message.success(this.$t('success'))
            }else{
                this.$Message.warning(this.$t('fail'))
                this.reloadView()
            }
        })
    },
    change9(){
        let status = ''
        if(this.switch17 && this.switch18){
            status = 'ET'
        }else if(!this.switch17 && this.switch18){
            status = 'T'
        }else if(this.switch17 && !this.switch18){
            status = 'E'
        }else if(!this.switch17 && !this.switch18){
            status = 'N'
        }
        setNoticeSetup({
            userId: this.token,
            account: status
        }).then(res=>{
            if(res.code === '0'){
                this.$Message.success(this.$t('success'))
            }else{
                this.$Message.warning(this.$t('fail'))
                this.reloadView()
            }
        })
    },
    reloadView(){
        physician.mine.getInformation({token:this.token}).then(res=>{
            let code = parseInt(res.code)
            if(!code){
                let data = JSON.parse(res.data)
                // console.log(data)
                this.$Spin.hide();
                this.loginInfo = JSON.parse(data.loginInfo)
                this.myProfile = JSON.parse(data.myProfile)
                // console.log(this.myProfile)
                this.softwareLicense = JSON.parse(data.softwareLicense)
                let hosArr = JSON.parse(data.myProfile).hospital.split(',')
                this.myProfile.hospital = hosArr
                console.log(hosArr)
            }
        })
    }
  },
  mounted () {
    this.token = localStorage.getItem('token') || sessionStorage.getItem('token')
    getAllDept({UserUID: this.token}).then(res=>{
        this.specialtylList = res.Dept
        console.log(res.Dept)
    })
    getNoticeSetup({
        userId: this.token
    }).then(res=>{
        console.log(res)
        if(res.code === '0'){
            if(res.autonewcase === 'ET'){
                this.switch1 = true
                this.switch2 = true
            }else if(res.autonewcase === 'E'){
                this.switch1 = true
                this.switch2 = false
            }else if(res.autonewcase === 'T'){
                this.switch1 = false
                this.switch2 = true
            }else if(res.autonewcase === 'N'){
                this.switch1 = false
                this.switch2 = false
            }

            if(res.autonewcomment === 'ET'){
                this.switch3 = true
                this.switch4 = true
            }else if(res.autonewcomment === 'E'){
                this.switch3 = true
                this.switch4 = false
            }else if(res.autonewcomment === 'T'){
                this.switch3 = false
                this.switch4 = true
            }else if(res.autonewcomment === 'N'){
                this.switch3 = false
                this.switch4 = false
            }

            if(res.customnewcase === 'ET'){
                this.switch5 = true
                this.switch6 = true
            }else if(res.customnewcase === 'E'){
                this.switch5 = true
                this.switch6 = false
            }else if(res.customnewcase === 'T'){
                this.switch5 = false
                this.switch6 = true
            }else if(res.customnewcase === 'N'){
                this.switch5 = false
                this.switch6 = false
            }

            if(res.customnewcomment === 'ET'){
                this.switch7 = true
                this.switch8 = true
            }else if(res.customnewcomment === 'E'){
                this.switch7 = true
                this.switch8 = false
            }else if(res.customnewcomment === 'T'){
                this.switch7 = false
                this.switch8 = true
            }else if(res.customnewcomment === 'N'){
                this.switch7 = false
                this.switch8 = false
            }

            if(res.statusupdates === 'ET'){
                this.switch9 = true
                this.switch10 = true
            }else if(res.statusupdates === 'E'){
                this.switch9 = true
                this.switch10 = false
            }else if(res.statusupdates === 'T'){
                this.switch9 = false
                this.switch10 = true
            }else if(res.statusupdates === 'N'){
                this.switch9 = false
                this.switch10 = false
            }

            if(res.modification === 'ET'){
                this.switch11 = true
                this.switch12 = true
            }else if(res.modification === 'E'){
                this.switch11 = true
                this.switch12 = false
            }else if(res.modification === 'T'){
                this.switch11 = false
                this.switch12 = true
            }else if(res.modification === 'N'){
                this.switch11 = false
                this.switch12 = false
            }

            if(res.completion === 'ET'){
                this.switch13 = true
                this.switch14 = true
            }else if(res.completion === 'E'){
                this.switch13 = true
                this.switch14 = false
            }else if(res.completion === 'T'){
                this.switch13 = false
                this.switch14 = true
            }else if(res.completion === 'N'){
                this.switch13 = false
                this.switch14 = false
            }

            if(res.profile === 'ET'){
                this.switch15 = true
                this.switch16 = true
            }else if(res.profile === 'E'){
                this.switch15 = true
                this.switch16 = false
            }else if(res.profile === 'T'){
                this.switch15 = false
                this.switch16 = true
            }else if(res.profile === 'N'){
                this.switch15 = false
                this.switch16 = false
            }

            if(res.account === 'ET'){
                this.switch17 = true
                this.switch18 = true
            }else if(res.account === 'E'){
                this.switch17 = true
                this.switch18 = false
            }else if(res.account === 'T'){
                this.switch17 = false
                this.switch18 = true
            }else if(res.account === 'N'){
                this.switch17 = false
                this.switch18 = false
            }
        }
    })
    this.$Spin.show({
        render: (h) => {
            return h('div', [
                h('Icon', {
                    'class': 'demo-spin-icon-load',
                    props: {
                        type: 'ios-loading',
                        color:'#f48221',
                        size: 18
                    }
                }),
                h('div',{
                    style: {
                        color: '#f48221'
                    },
                } ,'Loading')
            ])
        }
    });
        // eslint-disable-next-line no-irregular-whitespace
        let h = document.body.clientWidth
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.management-modal').forEach(i=>{
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom=h/1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal').forEach(i=>{
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom=h/1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal5').forEach(i=>{
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom=h/1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal1').forEach(i=>{
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom=h/1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        window.onresize = function(){
            // eslint-disable-next-line no-irregular-whitespace
            // console.log(h/1920 * 100 + '%')
            document.querySelectorAll('.custom-modal-details').forEach(i=>{
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom=h/1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal-case').forEach(i=>{
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom=h/1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal2').forEach(i=>{
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom=h/1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal1').forEach(i=>{
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom=h/1920 * 100 + '%'
            })
        }
        getAllHospital({UserUID: this.token}).then(res=>{
            let code = parseInt(res.code)
            if(!code){
                let hosList = JSON.parse(res.data)
                console.log(hosList)
                this.hospitalList = hosList
            }
        })
    this.reloadView()
}
}
